import api from "./api";

export const getHelpCategories = (params = {}) => {
  return api.get("/help/categories", { params });
};

export const getHelpArticles = (params = {}) => {
  return api.get("/help/articles", { params });
};

export const getHelpArticle = (articleId) => {
  return api.get(`/help/articles/${articleId}`);
};

export const createHelpArticleView = (articleId) => {
  return api.post(`/help/articles/${articleId}/view`);
};

export const createHelpArticleFeedback = (articleId, data) => {
  return api.post(`/help/articles/${articleId}/feedback`, data);
};

// Admin - Categories
export const createHelpCategory = (data) => {
  return api.post("/help/admin/categories", data);
};

export const updateHelpCategory = (categoryId, data) => {
  return api.put(`/help/admin/categories/${categoryId}`, data);
};

export const deleteHelpCategory = (categoryId) => {
  return api.delete(`/help/admin/categories/${categoryId}`);
};

// Admin - Articles
export const createHelpArticle = (data) => {
  return api.post("/help/admin/articles", data);
};

export const updateHelpArticle = (articleId, data) => {
  return api.put(`/help/admin/articles/${articleId}`, data);
};

export const deleteHelpArticle = (articleId) => {
  return api.delete(`/help/admin/articles/${articleId}`);
};

export default {
  getHelpCategories,
  getHelpArticles,
  getHelpArticle,
  createHelpArticleView,
  createHelpArticleFeedback,
  createHelpCategory,
  updateHelpCategory,
  deleteHelpCategory,
  createHelpArticle,
  updateHelpArticle,
  deleteHelpArticle
};
